<template>
  <div>
    <el-form-item
      :label=" $t('宽度')"
    >
      <el-input-number
        v-model="width"
        controls-position="right"
        :placeholder="$t('请输入')"
        :min="20"
      ></el-input-number>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "table-layout-th",
  inject: ["formDesign"],
  props: ["data"],
  data() {
    return {
    };
  },
  computed: {
    config() {
      return this.data.column;
    },
    width:{
      get(){
        return this.config.width
      },
      set(val){
        this.$set(this.config,'width',val)
      }
    }
  },
  methods: {},
};
</script>
